/**
 * Removes font-size declarations from inline style attributes on a given tag.
 * Needed because v-html terms from the API often ship fixed pixel sizes.
 */
export function stripInlineFontSize(html, tagName) {
  if (!html || !tagName) return html || ''

  const tagPattern = new RegExp(`(<${tagName}\\b[^>]*\\sstyle=["'])([^"']*)(["'])`, 'gi')

  return html.replace(tagPattern, (match, open, styles, close) => {
    const cleaned = styles
      .replace(/font-size\s*:\s*[^;"']+(!important)?\s*;?\s*/gi, '')
      .replace(/;\s*;/g, ';')
      .trim()
      .replace(/^;|;$/g, '')

    if (!cleaned) {
      return match.replace(/\sstyle=["'][^"']*["']/i, '')
    }

    return `${open}${cleaned}${close}`
  })
}

export function stripInlineFontSizeFromTags(html, tagNames) {
  if (!html) return ''
  return tagNames.reduce((acc, tag) => stripInlineFontSize(acc, tag), html)
}
